module.exports = __webpack_public_path__ + "static/media/Logo_McCormick.dcc858f4.png";